import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import AchieveOutcome from "../../components/AchieveOutcome/AchieveOutcome";
import {
    OverlayImg1, ProductHeroVideo, HealthVideo,
    CareCoordination,
    ClinicalInsights,
    EnvironmentalStewardship,
    FacilityAssetPerformance,
    OperationalAgility,
    PatientEngagement,
    QualityCompliance,
    ResearchInnovation,
    SupplyChainVisibility,
    WorkforceExcellence,
    AboutIED
} from "../../constant";
import WeAreIED from "../../components/WeAreIED";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import IndustriesVideoSection from "../../components/IndustiesVideoSection";
import ParaVideoSection from "../../components/IndustriesParaVideoSection";
import HealthAndPharmaLanding from "../../components/Industries/HealthAndPharmaLanding";
import TogetherSection from "../../components/Solution/TogetherChange";

const tabsData =
{
    title: "Enabling Better Outcomes Across the Care Continuum",
    subTitle: "From healthcare providers to pharmaceutical manufacturers, IENERGY helps organizations improve quality management, regulatory adherence, workforce effectiveness, and process efficiency while maintaining the highest standards of care and product integrity.",
    videoUrl: AboutIED,
    cardData: [
        {
            title: "Quality & Compliance",
            icon:QualityCompliance,
            description:
                "Built for Regulatory Excellence Ensure consistency across quality, audits, and compliance processes",
        },
        {
            title: "Workforce Excellence",
            icon:WorkforceExcellence,
            description:
                "People at the Center Strengthen workforce capability, accountability, and operational performance.",
        },
        {
            title: "Facility & Asset Performance",
            icon:FacilityAssetPerformance,
            description:
                "Keeping Critical Assets Running Maximize reliability across equipment, facilities, and infrastructure. ",
        },
    ],
    para: "Driving Sustainable Progress Measure impact, reduce waste, and support ESG initiatives."
};


const AnimatedCardCrausalData = [
    {
        title: "Care Coordination",
        icon:CareCoordination,
        description:
            "Delivering Seamless Patient Journeys,Improve collaboration across providers, caregivers, and care networks.",
    },
    {
        title: "Clinical Insights",
        icon:ClinicalInsights,
        description:
            "Turning Information into Better Outcomes,Enable evidence-based decisions through actionable clinical intelligence. ",
    },
    {
        title: "Research & Innovation",
        icon:ResearchInnovation,
        description: "Accelerating Discovery and Development,Support faster research cycles and innovation initiatives. ",
    },
    {
        icon:SupplyChainVisibility,
        title: "Supply Chain Visibility",
        description: "Strengthening Healthcare Networks,Improve traceability across inventory, distribution, and fulfillment.",
    },

    {
        title: "Patient Engagement",
        icon:PatientEngagement,
        description: "Creating More Connected Experiences,Enhance communication, accessibility, and patient participation. "
    },
    {
        icon:OperationalAgility,
        title: "Operational Agility",
        description: "Adapting to Evolving Healthcare Needs,Streamline processes and improve organizational responsiveness",
    },




];
const leftSecionData = {
    title: "Built for High-Performance Healthcare Organizations",
    para: ["From hospitals and diagnostic centers to pharmaceutical manufacturers and research organizations, success depends on balancing quality, compliance, workforce effectiveness, infrastructure reliability, and patient-centric services. IENERGY provides a unified foundation for managing quality programs, workforce readiness, facility operations, environmental initiatives, and enterprise performance. By bringing critical information and processes together, organizations can improve accountability, reduce administrative burden, and create a more responsive and resilient operating environment. "],
    mediaUrl: HealthVideo,
    imgeUrl: OverlayImg1,
}


export default function HealthAndPharma() {
    return (
        <>
            <HealthAndPharmaLanding />
            <IndustriesVideoSection data={tabsData} />
            <AnimatedCardCrausal
                title={"Innovative Solutions for Power & Renewables"}
                subTitle={"Optimize energy efficiency, enhance sustainability, and drive growth with our tailored solutions for the power and renewable energy sector."}
                data={AnimatedCardCrausalData}
            />

            <ParaVideoSection
                title={"Built for Modern Healthcare Enterprises"}
                subTitle={"Healthcare and pharmaceutical organizations require greater coordination across quality, workforce, facilities, compliance, and patient services. iEnergy helps organizations streamline critical processes, improve organizational effectiveness, and support better outcomes through integrated enterprise solutions."}
                data={leftSecionData}
            />
            <AchieveOutcome
                title={`Built for the Evolving Healthcare Landscape`}
                subTitle={`Equipping healthcare and pharmaceutical organizations with the tools and insights needed to improve performance, maintain trust, and adapt to changing industry demands. Creating stronger foundations for care delivery, innovation, operational stewardship, and long-term growth.`}
            />
            <WeAreIED />
            <TogetherSection
                title={"Transforming Industries Through Digital Innovation"}
                subTitle={"iEnergy delivers intelligent digital transformation solutions that empower enterprises to optimize operations, accelerate innovation and build connected, future-ready ecosystems across industries."}
            />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
